import { render, staticRenderFns } from "./ListShiteiResult.vue?vue&type=template&id=075a7c74&scoped=true&"
import script from "./ListShiteiResult.vue?vue&type=script&lang=js&"
export * from "./ListShiteiResult.vue?vue&type=script&lang=js&"
import style0 from "@/styles/table-styles.css?vue&type=style&index=0&id=075a7c74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075a7c74",
  null
  
)

export default component.exports